export const URL_SERVER = "https://ble.sg/api";

export const URL = {
  FIND_ALL_NEW: "/news/find-and-count-all",
  EMAIL_API: "/email/send",
};
